/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

interface ProductsGroupsState extends CommonState {}

const initialState: ProductsGroupsState = {
 ...initialCommonState,
};

const productsGroupsSlice = createSlice({
 name: 'productsGroups',
 initialState,
 reducers: {
  ...commonReducers,
 },
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemsStart,
 deleteItemsSuccess,
 deleteItemsFailure,
 deleteItemsFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,
 getItemDocumentsFinish,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,
} = productsGroupsSlice.actions;
export default productsGroupsSlice;
